import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import BoardMember from '~components/BoardMember';

import { circleImg } from '~theme';

const BoardMembers = () => (
  <div tw="grid gap-12 grid-cols-2 my-12 sm:(grid-cols-3 gap-12) md:(grid-cols-3 gap-12) lg:(grid-cols-4 gap-12)">
    <BoardMember name="Ron Miller, président" title="Partenaire, Lorem Partners">
      <StaticImage src="../../images/ron-miller-chair.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Lorne Shiff, Président sortant" title="Président LandCon Ltd.">
      <StaticImage src="../../images/lorne-shiff.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Murray Suey, Trésorier" title="Associé directeur régional, KPMG Calgary">
      <StaticImage src="../../images/murray-suey.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Mary Jane Devine, Secrétaire" title="Conseillère d’affaires en technologie de la santé">
      <StaticImage src="../../images/mary-jane-devine.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Justin Vineberg" title="Partenaire, Davies Ward Phillips & Vineberg LLP">
      <StaticImage src="../../images/justin-vineberg.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Helena Gottschling" title="Directrice des ressources humaines, RBC">
      <StaticImage src="../../images/helena-gottschling.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember
      name="Maarika Paul"
      title="Première vice-présidente et Cheffe de la Direction financière et des Opérations/Executive Vice-President and Chief Financial and Operations Officer CDPQ"
    >
      <StaticImage src="../../images/maarika-paul.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Dr David Kozloff" title="Membre du conseil FRDJ Canada">
      <StaticImage src="../../images/dr-david-kozloff.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Matthew Varey" title="Vice-président principal, RBC">
      <StaticImage src="../../images/matthew-varey.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Ashit Dattani" title="Conseiller en placement et gestionnaire de portefeuille, Gestion de patrimoine TD">
      <StaticImage src="../../images/ashit-dattani.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Dr Nick Hajidiacos" title="Médecin, Professeur adjoint de médecine">
      <StaticImage src="../../images/dr-nick-hajidiacos.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Réjean Tremblay" title="Directeur commercial au Canada, Aon">
      <StaticImage src="../../images/réjean-tremblay.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Scott Williams" title="Consultant principal, The Bronte Group">
      <StaticImage src="../../images/scott-williams.jpg" alt="" style={circleImg} />
    </BoardMember>
    <BoardMember name="Sean Murray" title="Président et chef de la direction, Advocate Printing & Publishing">
      <StaticImage src="../../images/sean-murray.jpg" alt="" style={circleImg} />
    </BoardMember>
  </div>
);

export default BoardMembers;
